import AppointmentApi from "@api/appointment";
import { APPOINTMENT_INFO } from "../mutationTypes";

const state = {
  appointmentInfo: {}
};

const getters = {
  // 预约状态
  appointmentStatus(store) {
    return store.appointmentInfo.could_apply_status || "0";
  },
  appliedAppointment(store){
    return store.appointmentInfo.applied_appointment ||[];
  }
};

const actions = {
  fetchAppointmentList({ commit }) {
    return AppointmentApi.fetchAppointmentList().then(data => {
      commit(APPOINTMENT_INFO, data);
    });
  }
};

const mutations = {
  [APPOINTMENT_INFO](state, data) {
    state.appointmentInfo = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
